/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "i18n/i18n",
  "api/v2/search",
  "client/template",
  "component!base",
  "client/templateregistry",
  "utils/dom",
  "utils/trace",
  "jquery",
  "!!raw-loader!../mustache/template.mustache",
  "underscore",
  "backbone",
  "utils/result",
  "utils/string",
  "mbmustache",
  "utils/browser",
  "jquery-ui-autocomplete"// dont remove it is used ny jQuery
], function(
  i18n,
  Search,
  Template,
  ComponentBase,
  TemplateRegistry,
  dom,
  Trace,
  $,
  DEFAULT_TEMPLATE,
  _,
  Backbone,
  resultUtils,
  StringUtils,
  Mustache,
  browser
) {
  var currentResultCount = 0;
  var inputModelCount;

  var ScrollSpyMini = function (scrollContainer, scrollTarget) {
    var that = this;
    
    if (scrollContainer.get(0) === document || scrollContainer.get(0) === document.documentElement || scrollContainer.is("body")) scrollContainer = window;

    this.$scrollTarget = $(scrollTarget)
    this.$scrollTarget.on("keydown", function (e) {
        if(e.keyCode === 13 || !e.keyCode === 9) {
          try {
            currentResultCount = that.$scrollTarget[0].parentElement.querySelectorAll(".media").length   
          } catch(e) {}
          that.activate(that.$scrollTarget);
        }
    });

    var callback = _.bind(this.process, this);
    this.$scrollContainer = $(scrollContainer).on("scroll.mb.scroll-spy-mini", callback);
    $(window).on("resize.mb.scroll-spy-mini", callback);
    this.process();
  };

  _.extend(ScrollSpyMini.prototype, {

    pageY: function(elem) {
      return elem.offsetParent ? (elem.offsetTop + this.pageY(elem.offsetParent)) : elem.offsetTop;
    },


    process: function () {
      if (!this.$scrollTarget.is(":visible")) {
        // set focus to next element
        try {
          var allResults = this.$scrollTarget[0].parentElement.querySelectorAll(".media");
          var lastFocusableResultCount = allResults && allResults.length - inputModelCount || 0;
          if (!browser.isMobileWidth() && allResults[lastFocusableResultCount]) {
            allResults[lastFocusableResultCount].querySelector(".media-heading a").focus();    
          }
        } catch(e) {}
        return; // we don't want to page, if the element is not visible
      }

      var scrollTop    = this.$scrollContainer.scrollTop();
      var $el = this.$scrollTarget;
      var offsetMethod = this.$scrollContainer[0] == window ? 'offset' : 'position'

      // var offset = $el[offsetMethod]().top + (!$.isWindow(this.$scrollContainer.get(0)) && this.$scrollContainer.scrollTop());
      var offset = $el[offsetMethod]().top;
      if (!$.isWindow(this.$scrollContainer.get(0))) {
        var pageYContainer = this.pageY(this.$scrollContainer.get(0));
        var pageYEl = this.pageY($el.get(0));
        offset = pageYEl - pageYContainer;
      }
      var bottomOffset = offset - this.$scrollContainer.outerHeight();

      var isFocusonTabKey = document.querySelector(".mb-highlight-focus .mb-scroll-placeholder");

      if (scrollTop >= bottomOffset && !isFocusonTabKey) {
        this.activate($el);
        return;
      }

      if(isFocusonTabKey && (document.activeElement == document.querySelector("body"))){
        try {
          var allResults = this.$scrollTarget[0].parentElement.querySelectorAll(".media")
    
          if (allResults[currentResultCount]) {
            allResults[currentResultCount].querySelector(".media-heading a").focus();    
          }
        } catch(e) {}
      }
    },

    activate: function (target) {
      target.trigger('activate')
    },

    destroy: function () {
      // what about multiple instances?
      this.$scrollContainer.off("scroll.mb.scroll-spy-mini");
      $(window).off("resize.mb.scroll-spy-mini");
    }
  });

  var label = i18n("preview");

  TemplateRegistry.add({
      id: "result",
      name: "editor_result_title",
      weight: 2,

      getAdders: function (context) {
        return [{
            name: "editor_result_template_list_title",
            icon: "../img/imglist.png",
            options: {
              template: DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default
            }
          },{
            name: "editor_result_template_imagegallery_title",
            icon: "../img/imggallery.png",
            options: {
              template: '<script type="text/x-mustache-template" data-tag-name="span"><a href="{{action}}" title="{{title}}">{{{icon}}}</a></script>'
            }
          },{
            name: "editor_result_template_table_title",
            icon: "../img/imgtable.png",
            options: {
              "data-template": "table",
              "data-properties": "mes:size,title",
              "no-default-template": true
            }
          },{
            name: "editor_result_template_map_title",
            icon: "../img/imgmap.png",
            options: {
              "data-template": "map",
              template: '<script type="text/x-mustache-template" data-tag-name="span"><a target="_blank" href="{{actions[0].href}}">{{{title}}}</a></script>'
            }
          },{
            name: "editor_result_template_timeline_title",
            icon: "../img/imgtimeline.png",
            options: {
              "data-template": "timeline",
              "no-default-template": true
            }
          },{
            name: "editor_result_template_suggestlist_title",
            icon: "../img/imgsuggestlist.png",
            options: {
              "data-template": "suggestlist",
              "no-default-template": true
            }
          },{
            name: "editor_result_counter",
            icon: "../img/resultcount.png",
            options: {
              "data-template": "resultcount",
              "no-default-template": true
            }
          }, {
            name: "editor_answer_box",
            icon: "../img/answer.png",
            group: {
              name: "answer"
            },
            options: {
              "data-template": 'answers',
              "no-default-template": true
            },
          },
          {
            name: "editor_search-info",
            icon: "../img/searchinfo.png",
            group: {
              name: "searchInfo"
            },
            options: {
              "data-template": 'searchinfo',
              "no-default-template": true
            },
          },
        ]
      },
      
      create: function (options) {
        var attributes = _.extend(
          {
            "data-template": "results"
          },
          _.reduce(options, function (filteredOptions, value, key) {
            if (/^data-/.test(key)) {
              filteredOptions[key] = value;
            }
            return filteredOptions;
          }, {})
        );
        return Backbone.View.prototype.make("div", attributes,
          options.template || (options["no-default-template"] === true ? "" : DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default)
        );
      }

  });

  var ResultsTemplate = Template.extend({

    editableName: "editor_result_title",

    initialize: function () {
      Template.prototype.initialize.apply(this, _.toArray(arguments));
      this.$el = $(this.el);
    },

    schema: new Template.Schema({
      inputAttributes: {
        view: {
          type: "reference",
          reference: "view"
        },
        appendonscroll: {
          title: "editor_result_append_on_scroll",
          type: "boolean",
          defaultValue: false
        },
        "enable-answers": {
          title: "editor_show_answers",
          type: "boolean",
          defaultValue: false,
          "default": false
        },
        "enable-optional-terms": {
          title: "editor_result_show_nonmatched_terms",
          type: "boolean",
          defaultValue: true,
          "default": true
        },
        "optional-terms-ratio": {
          title: "editor_result_optional_terms_ratio",
          type: "float",
          depends: "(!attributes['enable-optional-terms'] || /^true$/i.test(attributes['enable-optional-terms']))"
        },
        allowSymbolicPath: {
          title: "editor_result_allow_symbolic_path",
          type: "boolean",
          defaultValue: false
        },
        grouped: {
          title: "editor_result_grouped",
          type: "boolean",
          defaultValue: false,
          visible: false
        }
      }
    }),

    hasContent: function() { return true; },
    getContentSchema: function() {
      return  {
        type: "template"
      };
    },

    getDefaultTemplateAsEl: function() {
      var html = this.getDefaultTemplate();
      if (html) {
        return dom.instantiate(html);
      }
    },

    getContent: function() { return this.children[0].template; },

    createView: function(options)  {
      var resultTemplate = options.node.children[0].template;
      var view = new ResultsView(_.extend({}, options, {
            application: options.application,
            template: this,
            el: this.el,
            resultTemplate: resultTemplate,
            appendonscroll: this.el.getAttribute("data-appendonscroll") === "true",
            allowSymbolicPath: this.el.getAttribute("data-allow-symbolic-path") === "true",
            grouped: this.el.getAttribute("data-grouped") === "true",
            appendInBackground: this.el.getAttribute("data-appendinbackground") === "true",
            enableOptionalTerms: this.get("enable-optional-terms", options["enable-optional-terms"]),
            optionalTermsRatio: this.get("optional-terms-ratio", options["optional-terms-ratio"]),
      }));
      this.instances.push(view);
      return view;
    },

    remove: function (options) {
      _.forEach(this.instances, function (view) {
        view.remove();
      });
      this.instances = [];
      var nodeChildren = options && options.node && options.node.children;
      _.forEach(nodeChildren, function (childNode) {
        childNode && childNode.template && childNode.template.remove({
          node: childNode
        });
      });
    }
});

var $generatedEls = [];

ResultsTemplate.beforeTemplateTreeInitialization = function (rootEls, application) {
  $(rootEls).find('[data-template="results"]').each(function () {
    if ($(this).parents("[data-mb-exclude]").length > 0 || $(this).parents('div[data-template="search"]').length > 0) {
      // ignore if is child of data-mb-exclude and search component
      return;
    }

    var elementsFound = $(this).prevUntil('[data-template="results"]').filter('[data-generated-el-id="59681a28-1ca4-11ee-be56-0242ac120002"]');
    var foundAnwsersElement = elementsFound && elementsFound.length > 0;

    function answersAreDisabledInApplication (application) {
      return application && application.options &&
      (application.options.templateResultsEnableAnswers === "false" || application.options.templateResultsEnableAnswers === false);
    }

    var disabledInApplication = answersAreDisabledInApplication(application);
    if ($(this).attr('data-enable-answers') === "true" && !disabledInApplication) {
      if (!foundAnwsersElement) {
        var $answers = $('<div data-template="answers" data-generated-el-id="59681a28-1ca4-11ee-be56-0242ac120002" class="mb-answers-container" data-request-properties="false"></div>')
        $generatedEls.push($answers);
        $(this).before($answers);
      }
    } else {
      if (foundAnwsersElement) {
        elementsFound.each(function() {
          $(this).remove();
        });
      }
    }
  });
}

ResultsTemplate.beforeTemplateTreeDestroy = function (rootEls) {
  $generatedEls = _.filter($generatedEls, function ($generatedEl) {
    if ($(rootEls).find($generatedEl).length) {
      $generatedEl.remove();
      return false;
    }
    return true;
  })
}

var ResultsView = ComponentBase.extend({
  
  // this.options
  // this.el
  // this.model
  initialize: function () {
    inputModelCount = this.model.input && this.model.input.get("count") || 5;
    ComponentBase.prototype.initialize.apply(this, _.toArray(arguments));
  },

  setModel: function (model) {
    if (this.collection) {
      this.collection.off("add");
    }

    ComponentBase.prototype.setModel.apply(this, arguments);

    if (this.model) {
      var displayedProperties = this.getDisplayedProperties();

      if (this.options) {
        if (
          this.options.application &&
          this.options.application.options &&
          this.options.application.options.enhancedPDFPreview === true
        ) {
          displayedProperties['mes:contentpositionpage'] = resultUtils.mergeProperty(
            displayedProperties['mes:contentpositionpage'],
            { format: "VALUE" }
          );
        }

        var enableOptionalTerms = this.options.enableOptionalTerms;
        if (
          this.options.application &&
          this.options.application.options &&
          this.options.application.options.matchingOptions &&
          !_.isUndefined(this.options.application.options.matchingOptions.enableOptionalTerms)) {
          enableOptionalTerms = this.options.application.options.matchingOptions.enableOptionalTerms;
        }
        if (enableOptionalTerms) {
          displayedProperties['mes:nonmatchedterms'] = resultUtils.mergeProperty(
            displayedProperties['mes:nonmatchedterms'],
            { format: "VALUE" }
          );
          this.setOptionalTermsOptions();
        } else {
          if (this.model && _.isFunction(this.model.unset)) {
            this.model.unset("optional_terms_ratio", {silent: true});
            this.model.unset("term_boosting.position_boost_reduction_max", {silent: true});
            this.model.unset("term_boosting.position_boost_reduction_step", {silent: true});
            this.model.unset("term_boosting.disable_position_boost_reduction", {silent: true});
          }
        }
      }

      this.collection = new Search.ResultCollection(displayedProperties, { limitToPageSize: !this.options.appendonscroll, allowSymbolicPath: this.options.allowSymbolicPath });
      this.collection.on("add", this.addOne, this);
      this.collection.on("remove", this.removeOne, this);
      this.collection.on("updated", this.computed, this);
      if (this.model.options && this.model.options.enableImmediateDisplayOfFederatedResults) {
        this.collection.on("reset", this.computed, this);
      }
      this.model.addResultCollection(this.collection);
    }
  },

  setOptionalTermsOptions: function () {
    var optionalTermsRatio,
        maxTermBoost,
        reductionStep,
        disablePositionBoostReduction;

    if (!_.isUndefined(this.options.optionalTermsRatio)) {
      optionalTermsRatio = this.options.optionalTermsRatio;
    }

    // overwrite settings from application options
    if (
      this.options.application &&
      this.options.application.options) {
      if (!_.isUndefined(this.options.application.options.matchingOptions)) {
        var matchingOptions = this.options.application.options.matchingOptions;
        if (!_.isUndefined(matchingOptions.optionalTermsRatio)) {
          optionalTermsRatio = matchingOptions.optionalTermsRatio;
        }
      }

      if (!_.isUndefined(this.options.application.options.relevanceOptions)) {
        var relevanceOptions = this.options.application.options.relevanceOptions;
        if (!_.isUndefined(relevanceOptions.termBoostRelativeToPositionInQuery)) {
          var termBoostRelativeToPositionInQuery = relevanceOptions.termBoostRelativeToPositionInQuery;
          if (!_.isUndefined(termBoostRelativeToPositionInQuery.reductionStep)) {
            reductionStep = termBoostRelativeToPositionInQuery.reductionStep;
          }
          if (!_.isUndefined(termBoostRelativeToPositionInQuery.maxTermBoost)) {
            maxTermBoost = termBoostRelativeToPositionInQuery.maxTermBoost;
          }
          if (!_.isUndefined(termBoostRelativeToPositionInQuery.disablePositionBoostReduction)) {
            disablePositionBoostReduction = termBoostRelativeToPositionInQuery.disablePositionBoostReduction;
          }
        }
      }
    }

    this.setModelValues("optional_terms_ratio", optionalTermsRatio);
    this.setModelValues("term_boosting.position_boost_reduction_step", reductionStep);
    this.setModelValues("term_boosting.position_boost_reduction_max", maxTermBoost);
    this.setModelValues("term_boosting.disable_position_boost_reduction", disablePositionBoostReduction);
  },

  setModelValues: function (name, value) {
    if (!this.model || !this.model.unset) {
      return;
    }
    if (!_.isUndefined(value)) {
      this.model.set(name, value, {silent: true});
    } else {
      this.model.unset(name, {silent: true});
    }
  },

  triggerScrollPlaceholderVisibility: function (selector, trigger) {
    if (this.scrollPlaceholder) {
      try {
        var el = $($(this.scrollPlaceholder).find(selector)[0]);
        trigger === 'hide' ? el.hide() : el.show();
      } catch(e) {}
    }
  },

  computing: function () {
    this.triggerScrollPlaceholderVisibility('.load-more', 'hide');
    this.triggerScrollPlaceholderVisibility('.loading-more', 'show');
    
    this.pagingAllowed = false;
    ComponentBase.prototype.computing.apply(this, arguments);
  },

  computed: function () {
    this.triggerScrollPlaceholderVisibility('.load-more', 'show');
    this.triggerScrollPlaceholderVisibility('.loading-more', 'hide');

    this.removeScrollPlaceholder();
    this.pagingAllowed = true;

    if (this.options.appendonscroll === true && this.model && this.model.get("resultset.next_avail")) {
      _.defer(_.bind(this.appendScrollPlaceholder, this));
    }
    this.appendInBackgroundIfNeeded();
    ComponentBase.prototype.computed.apply(this, arguments);
  },

  appendInBackgroundIfNeeded: function() {
    if (this.options.appendInBackground === true && this.model && this.model.get("resultset.next_avail")) {
      _.defer(_.bind(this.appendInBackground, this));
    }
  },

  removeScrollPlaceholder: function () {
    $(this.scrollPlaceholder).off("activate");
    this.removeOwnedNode(this.scrollPlaceholder);

    delete this.scrollPlaceholder;

    if (this.scrollspy) {
      this.scrollspy.destroy();
      delete this.scrollspy;
    }
  },

  getDisplayedProperties: function () {
    const resultTemplate = this.options.resultTemplate;
    
    if (!resultTemplate) return {};

    // use case: properties from a mustache template (component)
    if (resultTemplate.properties) {
      return resultTemplate.properties;
    }

    // fallback - federate property retrival to child
    if (resultTemplate.getDisplayedProperties) {
      return resultTemplate.getDisplayedProperties();
    }

    return {};
  },

  /* TODO add this informatio to after Render? */
  _registerCollect: function(model, view) {
    if (this.options.application.models.collected) {
      var collectedItem = this.options.application.models.collected.get(model.get("location"));
      if (collectedItem) {
        view.$el.addClass("mb-collected");
      }
      view.listenTo(this.options.application.models.collected, "remove", function(model) {
        if (model.id == view.model.get("location")) {
          view.$el.removeClass("mb-collected");
        }
      }, view);
      view.listenTo(this.options.application.models.collected, "add", function(model) {
        if (model.id == view.model.get("location")) {
          view.$el.addClass("mb-collected");
        }
      }, view);

    }
  },

  getNonmatchedTermsTemplate: function () {
    return "<div class='mb-non-matched-terms'>\
      <span data-i18n='result_missing_term'>" + i18n("result_missing_term") + "</span>:\
      <ul>{{#mes:nonmatchedterms}}<li><strike>{{value}}</strike></li>{{/mes:nonmatchedterms}}</ul>\
      {{#showMustincludeterms}}\
        <span class='mb-separator'></span>\
        <span data-i18n='result_must_contain_term'>" + i18n("result_must_contain_term") + "</span>:\
        <ul>{{#mes:mustincludeterms}}<li><b><a role='button' class='action' tabindex='0' data-action-name='setNonMatchedTerm'>{{value}}</a></b></li>{{/mes:mustincludeterms}}</ul>\
      {{/showMustincludeterms}}</ul>\
    </div>";
  },

  addOne: function (model, collection, options) {
    var focus = document.activeElement === this.scrollPlaceholder || dom.isChild(document.activeElement, this.scrollPlaceholder);

    options = options || {};

    var leave = Trace.events.uiRender.enter(options.traceContext && options.traceContext.context, "results")
    try {
      var group = (model.get && model.get("mes:group")) || "";

      // TODO refactor - the template.js "options" (passed at createView) need a node in the options in order to create children
      // check if this is really nesseccary 
      const childNode = this.options.node.children[0];

      var viewOptions = {
        model: model, 
        modelType: "Result", 
        application: this.options.application,
        parent: this, 
        node: childNode,
        forceCreateNewElement: true
      }

      var position = options.at + (this.positionOffset || 0),
          view = this.options.resultTemplate.createView(viewOptions),
          viewEl = view.render().el;

      var nonmatchedTerms = model.get && model.get("mes:nonmatchedterms", {format: "VALUE"});

      if (nonmatchedTerms) {
        nonmatchedTerms = model.output.properties["mes:nonmatchedterms"].data;
        
        var optionalTerms = {
          "mes:nonmatchedterms": nonmatchedTerms
        };
 
        var unparsedUserQuery = this.options.application.getUnparsedUserQuery();
        var leftNonmatchedTerms = [];
        _.each(nonmatchedTerms, function(term) {
          var termIsIncludedInQuery = StringUtils.isTermIncludedInString(unparsedUserQuery, term.value);
          if (termIsIncludedInQuery) {
            leftNonmatchedTerms.push(term);
          }
        });

        if (leftNonmatchedTerms.length) {
          optionalTerms["showMustincludeterms"] = true;
          optionalTerms["mes:mustincludeterms"] = leftNonmatchedTerms;
        }

        if (nonmatchedTerms && nonmatchedTerms.length) {
          var $el = $(viewEl).find(".mb-content");
          if ($el.length) {
            var output = Mustache.render(this.getNonmatchedTermsTemplate(), optionalTerms);
            $el.append(output);
          } else {
            // In case there is not content, wrap it in order to be aligned correctly below the title
            var nonMatchTermsHTML = this.getNonmatchedTermsTemplate();
            var output =  "<div class='mb-content-default'>" +  Mustache.render(nonMatchTermsHTML, optionalTerms) + "</div>";
            var mediaBodyEl = $(viewEl).find(".media-body");

            if (mediaBodyEl.length) {
              $(mediaBodyEl).append(output);
            } else {
              $(viewEl).append(output);
            }
          }
        }
      }

      if (this.options.grouped) {
        this.insertGrouped(viewEl, position, group);
      }
      else {
        this.insertAt(viewEl, position);
      }

      if (focus) {
        dom.focus(viewEl, true);
      }

      this._registerCollect(model, view);
    } finally {
      leave.leave();
    }
    if (this.options.application && this.options.application.views) {
       this.options.application.views.trigger("afterRender:Result", this.options.application, view, model);
    }
    this.removeScrollPlaceholder();
  },

  removeOne: function (model) {
    var that = this;

    window.setTimeout(function () {
      _.each(that.groupEls, function (groupEl, key) {
        if (!groupEl.el.innerHTML && groupEl.parent.parentNode) {
          groupEl.parent.parentNode.removeChild(groupEl.parent);
        }
      });
    }, 0);
  },

  insertGrouped: function(viewEl, pos, group) {
    if (!this.groupEls) {
      this.groupEls = {};
    }
    if (group && _.isString(group.str)) group = group.str;

    var groupKey = group.toLowerCase();
    if (!this.groupEls[groupKey]) {
      var groupEl = this.make("div", {"data-group-id": groupKey, "class": "mb-result-group-container " + (groupKey.length > 0 ? groupKey.replace(/\s+/, "-") : "mb-empty-group")});
      var previousChild = null;
      var pos = -1;
      if (groupKey) {
        for (var i = 0; i < this.el.childNodes.length; i++) {
          try {
            var existingKey = this.el.childNodes[i].getAttribute("data-group-id");
            if (!existingKey) continue;
            if (groupKey < existingKey) {
              break;
            }
          } catch (e) {}
        }
      }
      if (pos == -1) {
        this.appendChild(groupEl, true);
      }
      else {
        this.insertAt(groupEl, pos, true);
      }

      if (group) {
        var titleEl = groupEl.appendChild(this.make("h2", {"class": "mb-group-title"}));
        titleEl.innerHTML =   group;
      }
      var el = groupEl.appendChild(this.make("div", {"class": "mb-group"}));
      this.groupEls[groupKey] = {parent: groupEl, el: el};
    }

    var el =  this.groupEls[groupKey].el;
    if (el.childNodes.length > pos) {
      el.insertBefore(viewEl, el.childNodes[pos]);
    } else {
      el.appendChild(viewEl);
    }

    if (!this.groupEls[groupKey].parent.parentNode) {
      this.appendChild(this.groupEls[groupKey].parent, true);
    }

    return this.groupEls[groupKey];
  },

  scrollPlaceholderAvailable: function() {
    return true;
  },

  appendScrollPlaceholderAndCreateScrollSpy: function() {
    var that = this;
    this.appendScrollPlaceholderEl();

    $(this.scrollPlaceholder).on("activate", function (e) {
      $(this.scrollPlaceholder).off("activate");
      that.page();
    });

    this.scrollspy = new ScrollSpyMini($(this.scrollPlaceholder).scrollParent(), this.scrollPlaceholder);
  },

  appendScrollPlaceholder: function () {
    if (this._removed || this.scrollPlaceholder) return;

    this.loadMoreResultsPlaceholder = this.make(
      "span",
      {
        "role": "button",
        "class": "mb-btn-default load-more"
      },
      i18n("mobileclient_load_more_results")
    );

    this.updateLoadMoreResultsPlaceholderListener();

    this.loadingMoreResultsPlaceholder = this.make(
      "span",
      {
        "role": "button",
        "class": "mb-pulse loading-more",
        "style": "display: none;"
      },
      i18n("loading_more_results")
    );

    this.scrollPlaceholder = this.make(
        "h3",
        {
          "tabindex": "0",
          "class": "mb-scroll-placeholder mb-center mb-no-print"
        }
    );

    this.scrollPlaceholder.appendChild(this.loadMoreResultsPlaceholder);
    this.scrollPlaceholder.appendChild(this.loadingMoreResultsPlaceholder);

    if (this.scrollPlaceholderAvailable()) {
      this.appendScrollPlaceholderAndCreateScrollSpy();
    }
    else {
      this.once("scrollplaceholderavailable", this.appendScrollPlaceholderAndCreateScrollSpy, this);
    }
  },

  updateLoadMoreResultsPlaceholderListener: function() {
    var that = this;
    $(this.loadMoreResultsPlaceholder).off('click');
    $(this.loadMoreResultsPlaceholder).on('click', function() {
      that.page();
    });
  },

  appendScrollPlaceholderEl: function () {
    this.appendChild(this.scrollPlaceholder, true);
  },

  appendInBackground: function() {
    if (this._removed) return;
    if (this.isComputing()) return;
    var that = this;
    this.handleActionObjectCall(
      {disablePropagateComputing: true,
       append: true,
       model: this.model, sender: this,
       computedCallback: function() {
         that.appendInBackgroundIfNeeded();
       }
      },
      "nextPage");
  },

  page: function () {
    if (this.isComputing()) return;
    if (!this.pagingAllowed) return;
    this.pagingAllowed = false;
    this.handleActionObjectCall({append: true, model: this.model, sender: this}, "nextPage");
  },

  render: function() {
    var el;

    return el;
  },

  remove: function () {
    this.removeScrollPlaceholder();
    ComponentBase.prototype.remove.apply(this, arguments);
    this.dispose();
    return this;
  },

  dispose: function () {
    this.collection.dispose();
  }
});

ResultsTemplate.DEFAULT_TEMPLATE = DEFAULT_TEMPLATE && DEFAULT_TEMPLATE.default;

ResultsTemplate.View = ResultsView;

return ResultsTemplate;
});
